const recipesList = {
    "inn-n-out-cheese-burger": {
      youtubeID: "3f0vm1k2SmI",
      videoCaption: "Featuring YouTube Video: Inn-N-Out Cheese Burger at Home | But Better by JD’s Kitchen",
      title: "Inn-N-Out Cheese Burger",
      date: "May 14, 2025",
      duration: "45 Minutes",
      difficulty: "Tiger",
      ingredients: {
        "Starter (Poolish)": [
          "50g Bread Flour",
          "50g Room Temperature Water",
          "Pinch of Yeast"
        ],
        "Burger Buns": [
          "350g Bread Flour",
          "170g Lukewarm Water",
          "20g Vegetable Shortening",
          "8g Sugar",
          "8g Salt",
          "6g Instant Yeast",
          "1 Egg"
        ],
        "Secret Spread Sauce": [
          "2 tbsp Unsalted Butter",
          "1/2 Yellow Onion",
          "1 Dill Pickle",
          "4 tbsp Ketchup",
          "2 tbsp Worcestershire Sauce",
          "2 cups Mayonnaise",
          "1 tbsp Pickling Liquid",
          "1/16 tsp MSG",
          "Salt & Pepper to Taste"
        ],
        "Burger": [
          "100g 80/20 Ground Beef",
          "Iceberg Lettuce",
          "Tomato",
          "Yellow Onion",
          "Mild Cheddar Cheese",
          "Salt & Pepper to Taste"
        ]
      },
      steps: {
        "Starter (Poolish)": [
          "In a large mixing bowl, whisk together bread flour, water, and a pinch of yeast until fully incorporated.",
          "Let rest at room temperature for about 14 hours."
        ],
        "Burger Buns": [
          "Mix lukewarm water, instant yeast, and sugar in a measuring cup. Let sit for 5 minutes until bubbly.",
          "In a large mixing bowl with the starter, combine yeasty mixture, bread flour, and salt. Knead until combined. Cover and let proof for 15 minutes.",
          "Transfer dough to a clean surface, add vegetable shortening, and knead for 4 minutes. Cover and proof for 30 minutes or until doubled.",
          "Divide dough into 6 portions, roll into balls, place on a bun tray, and press into molds. Cover and proof for 1 hour.",
          "Preheat oven to 400°F. Prepare egg wash by whisking 1 egg with water. Then strain egg wash mixture.",
          "Brush buns with egg wash. Bake for 10–15 minutes, rotating tray halfway. Optional: brush with melted butter after baking."
        ],
        "Secret Spread Sauce": [
          "Finely dice yellow onion. In a saucepan over medium heat, melt butter and cook onion with a pinch of salt for 10 minutes until caramelized.",
          "Finely dice dill pickle. In a mixing bowl, combine ketchup, mayo, pickle, Worcestershire sauce, pickling liquid, and MSG.",
          "Let caramelized onion cool to room temperature, then combine with sauce mixture. Season with salt and pepper to taste."
        ],
        "Burger": [
          "Slice yellow onion into 1/4 inch rings. Cook in butter over medium-high heat for 5–8 minutes, flipping halfway. Set aside.",
          "Portion ground beef into 100g balls. Heat skillet over medium-high. Add patties, season with salt and pepper, and smash down with spatula.",
          "Cook for 2–3 minutes per side. Add cheddar cheese and steam/melt until fully melted.",
          "Slice burger buns and toast both sides on the pan until golden brown.",
          "Assemble burger: bottom bun, spread sauce, tomato, lettuce, patty, caramelized onion, second patty, spread sauce, top bun."
        ]
      }
    }
  };
  
  export default recipesList;